var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHistoryIcon = function SvgHistoryIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-Style-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-743.000000, -163.000000)",
    fill: "white",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colors-Copy",
    transform: "translate(22.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M737.00594,145 C738.107229,145 739,145.894514 739,146.99406 L739,159.00594 C739,160.107229 738.105486,161 737.00594,161 L724.99406,161 C723.892771,161 723,160.105486 723,159.00594 L723,159 L735.999128,159 C736.515638,159 736.935912,158.613623 736.993316,158.115851 L737,157.999128 L737,145 L737.00594,145 Z M732.994141,143 C734.101946,143 735,143.89706 735,145.005859 L735,154.994141 C735,156.101946 734.10294,157 732.994141,157 L723.005859,157 C721.898054,157 721,156.10294 721,154.994141 L721,145.005859 C721,143.898054 721.89706,143 723.005859,143 L732.994141,143 Z M733,145 L723,145 L723,155 L733,155 L733,145 Z M731.00297,150 C731.514283,150 731.935699,150.38272 731.993292,150.882667 L732,151 C732,151.552285 731.546964,152 731.00297,152 L724.99703,152 C724.446386,152 724,151.556135 724,151 C724,150.447715 724.453036,150 724.99703,150 L731.00297,150 Z M731.00297,147 C731.514283,147 731.935699,147.38272 731.993292,147.882667 L732,148 C732,148.552285 731.546964,149 731.00297,149 L724.99703,149 C724.446386,149 724,148.556135 724,148 C724,147.447715 724.453036,147 724.99703,147 L731.00297,147 Z",
    id: "ic_menu_inquiry"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHistoryIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/history-icon.d8dd0ce0.svg";
export { ForwardRef as ReactComponent };